export interface TNotification {
  id: string;
  notificationTypeDefinitionId: string;
  notificationTypeName?: string | null;
  body: string | null;
  periodDays: number | null;
  isRead: boolean;
  triggerDate: string | null;
  createdAt: string;
  readAt: string | null;
  deliveryChannelsRequested: string[];
  deliveryStatus: string;
  entityType: ENotificationEntityType;
  entityId: string | null;
  title: string | null;
  subTitle: string | null;
  linkUrl: string | null;
  payloadJson: string | null;
  url?: string | null;
  executorName: string | null;
}

export type TNotificationStrategy = TNotification & {
  action: "NONE" | "REDIRECT";
  buildURL: string | null;
  actionLabel: string | null;
};

export type TPaginatedNotifications = {
  items: TNotification[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export enum ENotificationEntityType {
  Empty = "Empty",
  Policy = "Policy",
  PolicyVersion = "PolicyVersion",
  Client = "Client",
  Invoice = "Invoice",
  Claim = "Claim",
  BulkUpload = "BulkUpload",
}

export type TNotificationCenterFilter = {
  unreadOnly?: boolean;
};
